// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"262f3d2d","977":"ff0e054f"}[chunkId] + ".chunk.js";
};